<template>
    <div>页面丢失了</div>
</template>

<script>
export default {
  name: "NotFound"
}
</script>

<style scoped>

</style>
